import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AdultPartyContentSection from './components/AdultPartyContentSection';
import AdultPartyReservationSection from './components/AdultPartyReservationSection';

export default function EventsAdultsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AdultPartyContentSection />
        <AdultPartyReservationSection />
      </main>
      <Footer />
    </div>
  );
}